module.exports = __webpack_public_path__ + "img/15.64581345.jpg";